import axios from '../utilities/axios'

async function claimCouponCode(couponCode) {
  return axios.post('/api/v1/amd50/coupon', { couponCode })
}

async function submitShippingInformation(payload) {
  return axios.post('/api/v1/amd50/promotion', payload)
}

async function getTerms(typeId) {
  return axios.get(`/api/v1/terms?typeId=${typeId}`)
}

export default {
  claimCouponCode,
  submitShippingInformation,
  getTerms,
}
